import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { pickProductColor } from '../utils/shopify';
import CardDefault from '../components/Card/Default';
//import Background from '../components/Header/parts/Background';
//import TitleDefault from '../components/header/Title/Default';
//import linkResolver from '../../config/linkResolver';
//import { cover } from '../utils/styles';

const ProductMasonry = styled.section`
  position: relative;
  display: grid;
  grid-template-columns: repeat(4, 25vw);
  grid-template-rows: repeat(2, 25vh);
  align-items: center;
  justify-content: center;
  > *:first-child {
    grid-column-start: 1;
    grid-column-end: 3;
    grid-row-start: 1;
    grid-row-end: 3;
  }
`;

const ProductRows = styled.section`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 25vh;
`;

const HeroShopify = ({ input }) => {
  //eturn <h1>'WIP: Fixing'</h1>;
  switch (input.primary.layout_type) {
    case 'Masonry':
      return (
        <ProductMasonry>
          {input.items.map(x => (
            <CardDefault
              key={x.product.id}
              title={x.product.title}
              note={null}
              productType={x.product.product_type}
              currencyCode={'USD'}
              amount={x.product.variants[0].price}
              handle={x.product.handle}
              imageSrc={x.product.image.src || ''}
              imageAlt={x.product.image.alt || x.product.title}
              theme_light={pickProductColor(x.product.product_type).text}
              theme_dark={pickProductColor(x.product.product_type).background}
              is_dynamic
            />
          ))}
        </ProductMasonry>
      );
    case 'Rows':
    default:
      return (
        <ProductRows>
          {input.items.map(x => (
            <CardDefault
              key={x.product.id}
              title={x.product.title}
              note={null}
              productType={x.product.product_type}
              currencyCode={'USD'}
              amount={x.product.variants[0].price}
              handle={x.product.handle}
              imageSrc={x.product.image.src || ''}
              imageAlt={x.product.image.alt || x.product.title}
              theme_light={pickProductColor(x.product.product_type).text}
              theme_dark={pickProductColor(x.product.product_type).background}
            />
          ))}
        </ProductRows>
      );
  }
};

HeroShopify.propTypes = {
  input: PropTypes.object.isRequired,
};

export default HeroShopify;

/* <span>
          <Chip
            label={props.alias}
            background={true}
            theme_light={props.theme_light}
            theme_dark={props.theme_dark}
          />
        </span> */
